import { useEffect, useRef } from "react";

import { isBlank, netAmountOf } from "../utils/taxWithheld";

interface PrefilledAmount {
  amount: string;
  taxWithheld?: string | null;
}

export type AmountField = "amount" | "taxWithheld";

// A taxed earning prefills its gross, which would be posted as the net once the tax field hides.
export const useNetAmountWhileTaxHidden = (
  shouldShowTax: boolean,
  prefilled: PrefilledAmount | undefined,
  getValues: (name: AmountField) => string | null | undefined,
  setValue: (name: AmountField, value: string) => void,
) => {
  const wasTaxShown = useRef(shouldShowTax);

  useEffect(() => {
    if (wasTaxShown.current === shouldShowTax) {
      return;
    }
    wasTaxShown.current = shouldShowTax;

    const net = prefilled
      ? netAmountOf(prefilled.amount, prefilled.taxWithheld)
      : null;
    if (!prefilled || net === null) {
      return;
    }
    const [from, to] = shouldShowTax
      ? [net, prefilled.amount]
      : [prefilled.amount, net];
    if (Number(getValues("amount")) !== Number(from)) {
      return;
    }
    setValue("amount", String(to));
    if (shouldShowTax && isBlank(getValues("taxWithheld"))) {
      setValue("taxWithheld", String(prefilled.taxWithheld));
    }
  }, [shouldShowTax, prefilled, getValues, setValue]);
};
